export const years = function (startYear) {
  var currentYear = new Date().getFullYear(),
    years = [];
  startYear = startYear || 1950;
  while (startYear <= currentYear) {
    years.push(startYear++);
  }
  return years.reverse();
};
